import { gql } from '@apollo/client';

export const ORDER = gql`
  query Order($id: ID!) {
    order(id: $id) {
      id
      type
      date
      title
      createdById
      status
      data
      meta
      createdAt
      updatedAt
    }
  }
`;

export const ORDERS = gql`
  query Orders {
    orders {
      id
      type
      date
      title
      createdById
      status
      data
      meta
      createdAt
      updatedAt
    }
  }
`;
